import React from 'react';
import { IconButton, Tooltip, useTheme, Box } from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useThemeContext } from '../context/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { mode, toggleTheme } = useThemeContext();
  const theme = useTheme();
  const isDark = mode === 'dark';

  return (
    <Tooltip title={`Switch to ${isDark ? 'light' : 'dark'} mode`}>
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IconButton
          onClick={toggleTheme}
          color="inherit"
          aria-label="toggle theme"
          sx={{
            backgroundColor: isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
            transition: 'all 0.3s',
            '&:hover': {
              backgroundColor: isDark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)',
            },
          }}
        >
          {isDark ? (
            <Brightness7Icon sx={{ color: theme.palette.text.primary, transform: 'rotate(0deg)', transition: 'transform 0.5s ease' }} />
          ) : (
            <Brightness4Icon sx={{ color: theme.palette.text.primary, transform: 'rotate(0deg)', transition: 'transform 0.5s ease' }} />
          )}
        </IconButton>
      </Box>
    </Tooltip>
  );
};

export default ThemeToggle;